import React, { useState, useEffect } from "react";
import Header from "./Header";
import HeroSection from "./HeroSection";
import DifferentlySection from "./DifferentlySection";
import AboutSection from "./AboutSection";
import ServicesSection from "./ServicesSection";
import TestimonialsSection from "./TestimonialsSection";
import WorkSection from "./WorkSection";
import ContactSection from "./ContactSection";
import Footer from "./Footer";
import { useAppData } from "../hooks/useAppData";

const HomePage = () => {
  const [isLoading, setIsLoading] = useState(true);
  const { data, loading: dataLoading, error } = useAppData();

  useEffect(() => {
    // Wait for both initial loading and data loading to complete
    if (!dataLoading) {
      const timer = setTimeout(() => {
        setIsLoading(false);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [dataLoading]);

  if (isLoading || dataLoading) {
    return (
      <div className="min-h-screen bg-black flex items-center justify-center">
        <div className="text-white text-4xl font-light animate-pulse">
          reignite<span className="text-orange-500">health</span><span className="text-red-500">.</span>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-black flex items-center justify-center">
        <div className="text-center">
          <div className="text-white text-4xl font-light mb-4">
            reignite<span className="text-orange-500">health</span><span className="text-red-500">.</span>
          </div>
          <p className="text-white/60">Loading content...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-black text-white">
      <Header />
      <HeroSection data={data} />
      <DifferentlySection />
      <AboutSection data={data} />
      <ServicesSection data={data} />
      <TestimonialsSection data={data} />
      <WorkSection data={data} />
      <ContactSection data={data} />
      <Footer data={data} />
    </div>
  );
};

export default HomePage;